module.exports = __webpack_public_path__ + "static/img/tianjinwei.884695c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tianjinwei.png
// module id = jn+I
// module chunks = 1